import { combineReducers } from '@reduxjs/toolkit';
import auth from './auth';
import subscription from './subscription'

const rootReducer = combineReducers({
  auth,
  subscription
});

export default rootReducer;

export type RootState = ReturnType<typeof rootReducer>